// Cookie Consent Utility Functions
// These are exported separately to comply with react-refresh rules

const COOKIE_CONSENT_KEY = 'treffpunkts_cookie_consent';
const COOKIE_PREFERENCES_KEY = 'treffpunkts_cookie_preferences';

export interface CookiePreferences {
  necessary: boolean; // Always true, cannot be disabled
  analytics: boolean;
  marketing: boolean;
}

export const defaultCookiePreferences: CookiePreferences = {
  necessary: true,
  analytics: false,
  marketing: false,
};

export const getCookieConsent = (): boolean => {
  return localStorage.getItem(COOKIE_CONSENT_KEY) === 'true';
};

export const getCookiePreferences = (): CookiePreferences => {
  const stored = localStorage.getItem(COOKIE_PREFERENCES_KEY);
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch {
      return defaultCookiePreferences;
    }
  }
  return defaultCookiePreferences;
};

export const saveCookieConsent = (preferences: CookiePreferences): void => {
  localStorage.setItem(COOKIE_CONSENT_KEY, 'true');
  localStorage.setItem(COOKIE_PREFERENCES_KEY, JSON.stringify(preferences));
  
  // Dispatch custom event for analytics tracking
  window.dispatchEvent(new CustomEvent('cookieConsentUpdated', { detail: preferences }));
  
  // If analytics is accepted, log it
  if (preferences.analytics && typeof window !== 'undefined') {
    console.log('Analytics consent granted');
  }
};

export const hasAnalyticsConsent = (): boolean => {
  return getCookiePreferences().analytics;
};

export const hasMarketingConsent = (): boolean => {
  return getCookiePreferences().marketing;
};

export { COOKIE_CONSENT_KEY, COOKIE_PREFERENCES_KEY };
